/* sp-countdown-bar.js — geri sayım (metin yok; etiketler Liquid'den). Modlar: evergreen (localStorage), fixed (ISO), daily (UTC gece yarısı). */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(el) {
    if (el.dataset.spInit) return; el.dataset.spInit = '1';
    var mode = el.dataset.mode || 'evergreen';
    var hours = parseFloat(el.dataset.hours || '2') + (parseFloat(el.dataset.minutes || '0') / 60);
    var loadedAt = Date.now();
    var restart = el.dataset.restart === 'true';
    var key = el.dataset.key || 'sp-countdown';
    var nums = { h: el.querySelector('[data-unit="h"]'), m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]') };
    function endTime() {
      var now = Date.now();
      if (mode === 'fixed' && el.dataset.end) { var t = Date.parse(el.dataset.end); return isNaN(t) ? now : t; }
      if (mode === 'daily') { var d = new Date(now); return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1, 0, 0, 0); }
      if (mode === 'pageload') return loadedAt + hours * 3600000;
      var stored = null;
      try { stored = parseInt(localStorage.getItem(key), 10); } catch (e) {}
      if (!stored || isNaN(stored) || (stored < now && restart)) {
        stored = now + hours * 3600000;
        try { localStorage.setItem(key, String(stored)); } catch (e) {}
      }
      return stored;
    }
    var end = endTime();
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { if ((mode === 'evergreen' || mode === 'pageload') && restart) { loadedAt = Date.now(); end = endTime(); diff = end - Date.now(); } else if (mode === 'daily') { end = endTime(); diff = end - Date.now(); } else diff = 0; }
      var total = Math.floor(diff / 1000);
      var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
      if (nums.h) nums.h.textContent = String(h);
      if (nums.m) nums.m.textContent = pad(m);
      if (nums.s) nums.s.textContent = pad(s);
    }
    tick(); setInterval(tick, 1000);
  }
  function boot() { document.querySelectorAll('[data-sp-countdown]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
